(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  document.addEventListener('click', (event) => {
    const link = event.target.closest('[data-pa-cookie-preferences]');
    if (!link || typeof window.privacyBanner?.showPreferences !== 'function') return;
    event.preventDefault();
    window.privacyBanner.showPreferences().catch(() => { window.location.href = link.href; });
  });
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector(
          'input[name="locale_code"], input[name="country_code"]',
        ),
        button: this.querySelector('button'),
        panel: this.querySelector('ul'),
      };
      this.elements.button.addEventListener(
        'click',
        this.openSelector.bind(this),
      );
      this.elements.button.addEventListener(
        'focusout',
        this.closeSelector.bind(this),
      );
      this.querySelectorAll('a').forEach((item) =>
        item.addEventListener('click', this.onItemClick.bind(this)),
      );
    }

    onItemClick(event) {
      event.preventDefault();
      this.elements.input.value = event.currentTarget.dataset.value;
      this.querySelector('form')?.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute(
        'aria-expanded',
        (
          this.elements.button.getAttribute('aria-expanded') === 'false'
        ).toString(),
      );
    }

    closeSelector(event) {
      const shouldClose =
        event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.elements.button.setAttribute('aria-expanded', 'false');
        this.elements.panel.setAttribute('hidden', true);
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pa-instagram-gallery"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('pa-instagram-gallery')) {
    customElements.define('pa-instagram-gallery', class extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.pa-instagram-gallery__track');
        this.controls = this.querySelector('.pa-instagram-gallery__controls');
        this.previous = this.querySelector('[data-instagram-previous]');
        this.next = this.querySelector('[data-instagram-next]');
        if (!this.track || !this.controls || !this.previous || !this.next) return;
        this.abort?.abort();
        this.abort = new AbortController();
        const signal = this.abort.signal;
        const update = () => {
          if (this.frame) cancelAnimationFrame(this.frame);
          this.frame = requestAnimationFrame(() => {
            const maximum = this.track.scrollWidth - this.track.clientWidth;
            this.controls.hidden = maximum < 2;
            this.previous.disabled = this.track.scrollLeft <= 2;
            this.next.disabled = this.track.scrollLeft >= maximum - 2;
          });
        };
        const move = (direction) => {
          const card = this.track.querySelector('.pa-instagram-gallery__card');
          if (!card) return;
          const step = card.getBoundingClientRect().width + parseFloat(getComputedStyle(this.track).columnGap || '0');
          const behavior = matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
          this.track.scrollBy({ left: direction * step, behavior });
        };
        this.previous.addEventListener('click', () => move(-1), { signal });
        this.next.addEventListener('click', () => move(1), { signal });
        this.track.addEventListener('scroll', update, { signal, passive: true });
        this.observer?.disconnect();
        this.observer = new ResizeObserver(update);
        this.observer.observe(this.track);
        document.addEventListener('shopify:block:select', (event) => {
          const card = event.target.closest('.pa-instagram-gallery__card');
          if (card && this.contains(card)) card.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'auto' });
        }, { signal });
        update();
      }
      disconnectedCallback() {
        this.abort?.abort();
        this.observer?.disconnect();
        if (this.frame) cancelAnimationFrame(this.frame);
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
